import { ActionIcon, Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import LanguageMenuItems from './LanguageMenuItems.component';
import styles from './NavBarLanguageMenu.module.scss';

// flags can be found here : https://github.com/Yummygum/flagpack-core

const NavBarLanguageMenu = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language.toLowerCase().split('-')[0];

  return (
    <Menu position="bottom-end" offset={16}>
      <Menu.Target>
        <ActionIcon
          variant="default"
          size={36}
          gradient={{ from: 'blue', to: 'cyan', deg: 90 }}
          color="black"
          aria-label="Language"
          className={styles.iconButton}
        >
          <div className={styles.flag}>
            <img
              src={`/images/flags/${currentLanguage}.svg`}
              alt={`${currentLanguage} flag`}
              width="16"
              height="16"
            />
          </div>
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown className={styles.dropDownContainer}>
        <LanguageMenuItems />
      </Menu.Dropdown>
    </Menu>
  );
};

export default NavBarLanguageMenu;
